import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { JobLog } from '../domain/JobLog';
import { selectedRowDetails } from '../domain/selectedRowDetails';
import { ViewLog } from '../domain/ViewLog';

@Component({
    selector: 'app-view-logs',
    templateUrl: './view-logs.component.html',
    standalone: false
})

export class ViewLogsComponent {


  jobData: JobLog;

  selectedRowDetails: selectedRowDetails;

  constructor(public dialogRef: MatDialogRef<ViewLogsComponent>, @Inject(MAT_DIALOG_DATA) public data: ViewLog) {

    this.jobData = data.rowData;
  }

}